import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings section section--mini screen-start" }
const _hoisted_2 = { class: "settings__group" }
const _hoisted_3 = { class: "option settings__option" }
const _hoisted_4 = { class: "option__icon" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "option__name" }, "Language", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "option__value" }, "English", -1)
const _hoisted_7 = { class: "settings__group" }
const _hoisted_8 = { class: "option settings__option" }
const _hoisted_9 = { class: "option__icon" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "option__name" }, "Push notifications", -1)
const _hoisted_11 = { class: "option__value" }
const _hoisted_12 = { class: "settings__group" }
const _hoisted_13 = { class: "option__icon" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "option__name" }, "Support", -1)
const _hoisted_15 = { class: "option__icon" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "option__name" }, "FAQ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "option__icon" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "option__name" }, "Referral link", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "option__icon" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "option__name" }, "Seed code", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "settings__group" }
const _hoisted_24 = {
  href: "#",
  target: "_blank",
  class: "option settings__option"
}
const _hoisted_25 = { class: "option__icon" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "option__name" }, "User Agreement", -1)

import "./SettingsView.scss";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import Switch from "@/components/Switch/Switch.vue";
import Icon from "@/components/Icon/Icon.vue";
import {ref, watch} from "vue";
import {useUserStore} from "@/stores/userStore";
import {useAlertsStore} from "@/stores/alertsStore";
import {useApiStore} from "@/stores/apiStore";
import TelegramWebApp from "@/telegram/TelegramWebApp";
import {storeToRefs} from "pinia";
import copy from "copy-to-clipboard";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

let userStore = useUserStore();
let alertsStore = useAlertsStore();
let {api} = useApiStore();

let {me} = storeToRefs(userStore);

let pushesEnabled = ref<boolean>(me.value!.is_pushes_enabled);

watch(pushesEnabled, async () => {

	await api.changeSettings({
		is_pushes_enabled: !!pushesEnabled.value,
	})

	me.value!.is_pushes_enabled = !!pushesEnabled.value

});

function openShareLink(){

	let text = 'Привет!';
	let inviteLink = 'https://t.me/sdlksakdaskldlkasbot?start=' + me.value!.chat;

	TelegramWebApp.app!.openTelegramLink('https://t.me/share/url?url=' + encodeURIComponent(inviteLink) + '&text=' + encodeURIComponent(text));

}

function copySeed(){

	copy(me.value!.seed);

	alertsStore.pushSuccess('Was copied to clipboard!');

}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(AdditionalLayout, { title: "Settings" }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", _hoisted_3, [
            _createElementVNode("i", _hoisted_4, [
              _createVNode(Icon, { name: "language" })
            ]),
            _hoisted_5,
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _createElementVNode("i", _hoisted_9, [
              _createVNode(Icon, { name: "notifications" })
            ]),
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, [
              _createVNode(Switch, {
                modelValue: _unref(pushesEnabled),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pushesEnabled) ? (pushesEnabled).value = $event : pushesEnabled = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_RouterLink, {
            class: "option settings__option",
            to: "/support"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", _hoisted_13, [
                _createVNode(Icon, { name: "support" })
              ]),
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            class: "option settings__option",
            to: "/faq"
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", _hoisted_15, [
                _createVNode(Icon, { name: "question" })
              ]),
              _hoisted_16
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "button",
            class: "option settings__option",
            onClick: openShareLink
          }, _hoisted_19),
          _createElementVNode("button", {
            class: "option settings__option",
            type: "button",
            onClick: copySeed
          }, _hoisted_22)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("a", _hoisted_24, [
            _createElementVNode("i", _hoisted_25, [
              _createVNode(Icon, { name: "page" })
            ]),
            _hoisted_26
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})